import React, { StrictMode } from "react"; //Suspense
import ReactDOM from "react-dom/client";
import "./index.css";
import { Provider } from "react-redux";
import store from "./store/store";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "@asgardeo/auth-react";
import { asgardeoConfig } from "./services/asgardeo-config";
import GroupGuard from "./components/GroupGuard/GroupGuard";
import TagManager from "react-gtm-module";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import RateLimitNotice from "./components/RateLimitNotice/RateLimitNotice";

// Lazy Load App for Better Performance
// const App = lazy(() => import("./App"));


// Optimize Google Tag Manager (Load When Browser is Idle)
const tagManagerArgs = {
  gtmId: import.meta.env.VITE_GTM_ID,
};

if ("requestIdleCallback" in window) {
  requestIdleCallback(() => TagManager.initialize(tagManagerArgs));
} else {
  setTimeout(() => TagManager.initialize(tagManagerArgs), 3000); // Fallback for older browsers
}

// Set future flags for React Router v7
const routerOptions = {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true
  }
};

const getAuthParams = async () => {
  const params = new URLSearchParams(window.location.search);
  const authorizationCode = params.get("code");
  const sessionState = params.get("session_state");
  const state = params.get("state");

  return {
    authorizationCode: authorizationCode || undefined,
    sessionState: sessionState || undefined,
    state: state || undefined
  };
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    <BrowserRouter {...routerOptions}>
      <Provider store={store}>
        <AuthProvider config={asgardeoConfig} getAuthParams={getAuthParams}>
          <RateLimitNotice />
          <GroupGuard>
            <HelmetProvider>
              <App />
            </HelmetProvider>
          </GroupGuard>
        </AuthProvider>
      </Provider>
    </BrowserRouter>
  </StrictMode>
);
